import React from 'react';
import { Button } from 'primereact/button';

const OdcSalesHeader = ({ sessionInfo, onBack }) => {
    return (
        <div className="mb-4">
            <div className="flex align-items-center justify-content-between">
                <div className="flex align-items-center gap-3">
                    <Button
                        icon="pi pi-arrow-left"
                        className="p-button-rounded p-button-text p-button-plain surface-0 shadow-1"
                        onClick={onBack}
                    />
                    <div>
                        <h2 className="text-3xl font-bold mb-1" style={{ color: 'var(--primary-color)' }}>
                            Take <span className="text-blue-600">Fresh Order</span>
                        </h2>
                        <p className="text-color-secondary m-0">Fill in order details and add items to cart</p>
                    </div>
                </div>
                <div className="font-bold text-sm uppercase px-3 py-2 surface-0 border-round shadow-1 text-700">
                    <i className="pi pi-map-marker mr-2 text-primary" />
                    Branch: {sessionInfo.ubranch}
                </div>
            </div>
        </div>
    );
};

export default OdcSalesHeader;
